import React from 'react';

import { Layout } from 'ds';
import thinkingGif from 'shared/assets/Thinking.gif';

import AIAssistantSystemMessage from './AIAssistantSystemMessage';

interface Props {}

const AIAssistantThinkingDisplay: React.FC<Props> = () => {
  return (
    <AIAssistantSystemMessage thinking>
      <Layout flex width={40} height={40}>
        <img
          src={thinkingGif}
          alt="AI is thinking"
          width={40}
          height={40}
          style={{ objectFit: 'contain', objectPosition: 'center' }}
        />
      </Layout>
    </AIAssistantSystemMessage>
  );
};

export default AIAssistantThinkingDisplay;
